import axiosInstance from './axiosConfig';

/**
 * Get all active testimonials
 * @returns {Promise} Response with testimonials data
 */
export const getTestimonials = async () => {
  const response = await axiosInstance.get('/laptops/testimonials');
  return response.data;
};
